export default function DeleteEndnoteConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  pmDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.isInUse = false;

  _activate();

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _activate() {
    if (vm.endnote.policyDocumentSections !== null) {
      vm.isInUse = true;
    }
  }

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    return pmDataService.deleteEndnote(vm.endnote.policyDocumentEndNoteId).then(() => {
      alerts.success(`Endnote "${vm.endnote.name}" was successfully deleted.`);
      $rootScope.$broadcast('pmEndnoteDeleted', vm.endnote.policyDocumentEndNoteId);
      if (vm.updateCallBack) {
        vm.updateCallBack();
      }
      _closeDialog($event);
    }).catch(() => {
      alerts.error('Error occurred while deleting Endnote.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */
  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.confirmDeleteEndnoteDialog);
  }
}

DeleteEndnoteConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'pmDataService',
  'loaderService',
  'ssDialogService'
];
